<app-decarbonization-type-list
    [regions]="regions"
    [types]="selfVehicleTypes"
    [removableTypesId]="removableVehicleTypesId"
    [canCreateDecarbonizationTypes]="canCreateDecarbonizationTypes"
    [canManageRegionDecarbonizationTypes]="canManageRegionDecarbonizationTypes"
    [typeCreationButtonKey]="'decarbonization.vehicle-types.creation-modal.add-button'"
    [typeAddRegionButtonKey]="'decarbonization.vehicle-types.region-add.add-button'"
    [titleKey]="'decarbonization.vehicle-types.title'"
    [searchTitleKey]="'decarbonization.vehicle-types.search-title'"
    [searchPlaceholderKey]="'decarbonization.vehicle-types.search-placeholder'"
    (openTypeCreationModal)="openVehicleTypeCreationModal()"
    (openRegionTypeAddModal)="openRegionVehicleTypeAddModal()"
    (deleteItem)="openVehicleTypeDeletionModal($event)"
    (removeRegionItem)="openVehicleTypeRegionRemovalModal($event)"
></app-decarbonization-type-list>

<ng-template #vehicleTypeCreationModal>
    <div>
        <h3 [i18n]="'decarbonization.vehicle-types.creation-modal.description'"></h3>
        <input type="text"
               class="form-control"
               [(ngModel)]="newVehicleType"
               [i18n]="[{target: 'attribute:placeholder', key: 'decarbonization.vehicle-types.creation-modal.input-placeholder'}]">
    </div>
</ng-template>

<ng-template #regionVehicleTypeAddModal>
    <div>
        <h3 [i18n]="'decarbonization.vehicle-types.region-add.description'"></h3>
        <ng-select class="grow"
                   [items]="filteredVehicleTypes"
                   [bindLabel]="'label'"
                   [hideSelected]="true"
                   [(ngModel)]="selectedVehicleType"
                   [i18n]="[
                            {target: 'attribute:placeholder', key: 'decarbonization.fuel-types.region-add.dropdown-placeholder'},
                            {target: 'attribute:notFoundText', key: 'decarbonization.fuel-types.region-add.dropdown-empty'}
                           ]">
        </ng-select>
    </div>
</ng-template>

<ng-template #vehicleTypeDeletionModal>
    <div class="row">
        <div class="col-xs-12 text-center" [i18n]="'decarbonization.vehicle-types.deletion-modal.description'"></div>
    </div>
</ng-template>

<ng-template #vehicleTypeRegionRemovalModal>
    <div class="row">
        <div class="col-xs-12 text-center" [i18n]="'decarbonization.vehicle-types.remove-region-modal.description'"></div>
    </div>
</ng-template>
